import makeLookupModal from "../../UI/LookupModal/LookupModal";
import DepartmentLookup from "./DepartmentLookup";
const DepartmentLookupModal = makeLookupModal(DepartmentLookup, {
    pluralEntityName: "Departments",
});
export default DepartmentLookupModal;
